import { teamsContextStore } from 'state/teamsContext';
import type { YammerTeamsNativeState } from 'state/types';

import { lazyResetTeamsClientDataLayer } from './loadableResetTeamsClientDataLayer';
import { triggerCacheSync } from './serviceWorkerCacheSync';
import { unsubscribeTeamsFromPageLifecycleEvents } from './teamsPageLifecycleEvents';

type HandleBeforeUnloadApp = (readyToUnload: () => void, getState: (() => YammerTeamsNativeState) | null) => boolean;

export const handleBeforeUnloadApp: HandleBeforeUnloadApp = (readyToUnload, getState) => {
  lazyResetTeamsClientDataLayer();
  unsubscribeTeamsFromPageLifecycleEvents();

  triggerCacheSync(getState);

  readyToUnload();

  teamsContextStore.getState().setIsCached(true);

  return true;
};
